import { AppLayout } from '@sorare/gameplay/src/components/navigation/AppLayout';

import { Careers as CareersContent } from 'Careers';

const Careers = () => (
  <AppLayout>
    <CareersContent />
  </AppLayout>
);

export default Careers;
